import React, { FC } from "react"

import "./index.scss"

type IBarRankProps = {
  data: { value: number; name: string }[]
  // barWidth?: number
  color?: string[]
}

const BarRank: FC<IBarRankProps> = ({
  data = [],
  // barWidth = 28,
  color = ["rgba(123, 210, 139, 1)", "rgba(138, 244, 210, 1)"],
}) => {
  return (
    <div className="ct-bar-top" style={{ height: "100%" }}>
      {data.map((item, i) => {
        return (
          <div className="it" key={i}>
            <div className="label">{item.name}</div>
            <div className="bg" style={{ height: ".6rem" }}>
              <div
                className="idx"
                style={{
                  background:
                    "linear-gradient(90deg,rgba(123,210,139,0.7) 0%,rgba(138,244,210,0.7) 100%)",
                  width: (item.value / data[0].value) * 100 + "%",
                }}
              ></div>
            </div>
            <div className="value">{Math.round(item.value * 100)}%</div>
          </div>
        )
      })}
    </div>
  )
}

export default BarRank
